import { inject, Injectable } from '@angular/core';
import { EPermissaoAplication } from '../banner-slides/contracts/enums/permissao-aplication.enum';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';
import { IBannerSlide } from '../banner-slides/contracts/interfaces/banner-slide.interface';
import { EProductAplication } from '../banner-slides/contracts/enums/product-aplication.enum';

@Injectable({
  providedIn: 'root'
})
export class ModalComunicadoService {
  private apiUsuarioService = inject(ApiUsuarioService)

  private readonly CONFIG_KEY = 'comunicadosVisualizados';
  
  public setViewed(communicationId: string) {
    const comunicadosVisualizados = this.getViewedStorage();

    if (!comunicadosVisualizados.includes(communicationId)) {
      comunicadosVisualizados.push(communicationId);
      this.apiUsuarioService.salvarConfigs({ [this.CONFIG_KEY]: comunicadosVisualizados }).subscribe({
        error: (error) => console.error('Erro ao salvar comunicados visualizados:', error)
      });
    }
  }

  public getViewedStorage(): string[] {
    const prefs = this.apiUsuarioService.userPreferences;
    return prefs && Array.isArray(prefs[this.CONFIG_KEY]) ? prefs[this.CONFIG_KEY] : [];
  }

  public filterValidSlides(
    data: IBannerSlide,
    produtosValidos: EProductAplication[]
  ): boolean {
    const now = new Date();
    const isUserAdmin = this.apiUsuarioService.isUserAdmin();

    const isDateInRange = (start?: string, end?: string): boolean => {
      const startDate = start ? new Date(start) : null;
      const endDate = end ? new Date(end) : null;
      return (!startDate || now >= startDate) && (!endDate || now <= endDate);
    };    

    const hasValidProduct = data.Produto.some(p => produtosValidos.includes(p));

    return (
      data.Ativo && hasValidProduct && isDateInRange(data.Inicio, data.Fim) && this.hasValidPermission(isUserAdmin, data?.Permissao) 
    );
  }

  public hasValidPermission = (isUserAdmin: boolean, permissao?: EPermissaoAplication): boolean => {
    if (permissao == null || permissao === EPermissaoAplication.TODOS) {
      return true;
    }
    
    switch (permissao) {
      case EPermissaoAplication.ADMINISTRADOR:
        return isUserAdmin;

      case EPermissaoAplication.USUARIO:
        return !isUserAdmin;

      default:
        return false;
    }
  };
}